import { styled } from "styled-components";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";

const TableActionButton = (props) => {
    return (
        <CustomButton bg={props.bg} onClick={props.onPress}>
            {props.children}
            {props.bg === '#ff6b6b' ? <AiOutlineDelete size='1.6rem' /> : <AiOutlineEdit size='1.6rem' />}
        </CustomButton>
    );
}

export default TableActionButton;


const CustomButton = styled.button`
    background-color: ${props => props.bg};
    width: 10rem;
    height: 3rem;
    color: white;
    font-size: 1.4rem;
    letter-spacing: 0.125rem;
    text-align: center;
    padding: 4px 2px;
    border: none;
    border-radius: 0.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin: auto;
    cursor: pointer;
    &:hover {
        transform: translateY(-2px);
        box-shadow: 5px 5px 5px #ccc;
    }
    &:active {
        transform: translateY(0);
        box-shadow: 3px 3px 3px #ccc;
    }
`;